import {canonicalModuleKey,canonicalModuleKeys,isCoreNavigationModule,isCoreBusinessModule} from './moduleKeys';

export function entitlementKeys(key){
  const canonical=canonicalModuleKey(key);
  return canonical?[canonical]:[];
}

export function hasModuleEntitlement(enabled,key,enforce=true){
  const canonical=canonicalModuleKey(key);
  if(!canonical||isCoreNavigationModule(canonical)||isCoreBusinessModule(canonical)||!enforce)return true;
  const set=new Set(canonicalModuleKeys(enabled));
  return set.has(canonical);
}

export function roleAllowsModule(roleModules,key){
  const canonical=canonicalModuleKey(key);
  if(!canonical||isCoreNavigationModule(canonical))return true;
  const roles=canonicalModuleKeys(roleModules);
  if(!roles.length||roles.includes('all'))return true;
  return new Set(roles).has(canonical);
}
